import {Component, Inject} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RouterLink } from '@angular/router';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'please-register-dialog-component',
    templateUrl: 'please-register-dialog.html',
    styleUrls: ['./please-register-dialog.scss'],
    imports: [RouterLink, MatButton]
})
export class PleaseRegisterDialog {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<PleaseRegisterDialog>) {
     }

  onNoClick(): void {
    this.dialogRef.close();
  }

  closeInfocard() {
    this.dialogRef.close();
  }

}
